module.exports = __webpack_public_path__ + "static/media/downwardArrow.4bb5abd7.svg";